// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/styling-" + {"63598":"5097533d921f1eea007d","95459":"02e5fb58d191d0d7df77"}[chunkId] + ".css";
};